module.exports = __webpack_public_path__ + "img/行走BAR.9b9057a6.png";